var map = {
	"./Error": [
		40965,
		7,
		7407,
		8898,
		965
	],
	"./Error.tsx": [
		40965,
		7,
		7407,
		8898,
		965
	],
	"./Loading": [
		71459,
		9,
		7407,
		8898,
		1459
	],
	"./Loading.tsx": [
		71459,
		9,
		7407,
		8898,
		1459
	],
	"./declaration/Crypto": [
		41618,
		7,
		7407,
		8898,
		1618
	],
	"./declaration/Crypto.tsx": [
		41618,
		7,
		7407,
		8898,
		1618
	],
	"./declaration/Inbt": [
		84424,
		7,
		7407,
		8898,
		4424
	],
	"./declaration/Inbt.tsx": [
		84424,
		7,
		7407,
		8898,
		4424
	],
	"./declaration/Ofbt": [
		66229,
		7,
		7407,
		8898,
		6229
	],
	"./declaration/Ofbt.tsx": [
		66229,
		7,
		7407,
		8898,
		6229
	],
	"./declaration/OfbtLegacy": [
		53352,
		7,
		7407,
		8898,
		3352
	],
	"./declaration/OfbtLegacy.tsx": [
		53352,
		7,
		7407,
		8898,
		3352
	],
	"./declaration/TisgServices": [
		32594,
		7,
		7407,
		8898,
		2594
	],
	"./declaration/TisgServices.tsx": [
		32594,
		7,
		7407,
		8898,
		2594
	],
	"./deposit/AlreadyConfirmed": [
		9085,
		7,
		7407,
		8898,
		9085
	],
	"./deposit/AlreadyConfirmed.tsx": [
		9085,
		7,
		7407,
		8898,
		9085
	],
	"./deposit/Cancelled": [
		77167,
		7,
		7407,
		8898,
		7167
	],
	"./deposit/Cancelled.tsx": [
		77167,
		7,
		7407,
		8898,
		7167
	],
	"./deposit/CardNoApplicablePsp": [
		94442,
		7,
		7407,
		8898,
		4442
	],
	"./deposit/CardNoApplicablePsp.tsx": [
		94442,
		7,
		7407,
		8898,
		4442
	],
	"./deposit/ConfirmationExpired": [
		67029,
		7,
		7407,
		8898,
		7029
	],
	"./deposit/ConfirmationExpired.tsx": [
		67029,
		7,
		7407,
		8898,
		7029
	],
	"./deposit/Expired": [
		51060,
		7,
		7407,
		8898,
		1060
	],
	"./deposit/Expired.tsx": [
		51060,
		7,
		7407,
		8898,
		1060
	],
	"./deposit/ExpiredV2": [
		29801,
		7,
		7407,
		8898,
		9801
	],
	"./deposit/ExpiredV2.tsx": [
		29801,
		7,
		7407,
		8898,
		9801
	],
	"./deposit/Failed": [
		75608,
		7,
		7407,
		8898,
		5608
	],
	"./deposit/Failed.tsx": [
		75608,
		7,
		7407,
		8898,
		5608
	],
	"./deposit/HostIframe": [
		29490,
		9,
		9490
	],
	"./deposit/HostIframe.tsx": [
		29490,
		9,
		9490
	],
	"./deposit/Index": [
		18827,
		7,
		7407,
		8898,
		8827
	],
	"./deposit/Index.tsx": [
		18827,
		7,
		7407,
		8898,
		8827
	],
	"./deposit/Interrupted": [
		16980,
		7,
		7407,
		8898,
		6980
	],
	"./deposit/Interrupted.tsx": [
		16980,
		7,
		7407,
		8898,
		6980
	],
	"./deposit/ModalClosed": [
		45129,
		7,
		7407,
		8898,
		5129
	],
	"./deposit/ModalClosed.tsx": [
		45129,
		7,
		7407,
		8898,
		5129
	],
	"./deposit/NoApplicablePsp": [
		1555,
		7,
		7407,
		8898,
		1555
	],
	"./deposit/NoApplicablePsp.tsx": [
		1555,
		7,
		7407,
		8898,
		1555
	],
	"./deposit/PaymentStatus": [
		83008,
		7,
		3008
	],
	"./deposit/PaymentStatus.tsx": [
		83008,
		7,
		3008
	],
	"./deposit/Pending": [
		69675,
		7,
		7407,
		8898,
		9675
	],
	"./deposit/Pending.tsx": [
		69675,
		7,
		7407,
		8898,
		9675
	],
	"./deposit/Processing": [
		36921,
		7,
		7407,
		8898,
		6921
	],
	"./deposit/Processing.tsx": [
		36921,
		7,
		7407,
		8898,
		6921
	],
	"./deposit/Success": [
		84891,
		7,
		7407,
		8898,
		4891
	],
	"./deposit/Success.tsx": [
		84891,
		7,
		7407,
		8898,
		4891
	],
	"./identity-verification/CardCancelled": [
		91369,
		7,
		7407,
		8898,
		1369
	],
	"./identity-verification/CardCancelled.tsx": [
		91369,
		7,
		7407,
		8898,
		1369
	],
	"./identity-verification/CardFailed": [
		84555,
		7,
		7407,
		8898,
		4555
	],
	"./identity-verification/CardFailed.tsx": [
		84555,
		7,
		7407,
		8898,
		4555
	],
	"./identity-verification/CardSuccess": [
		72518,
		7,
		7407,
		8898,
		2518
	],
	"./identity-verification/CardSuccess.tsx": [
		72518,
		7,
		7407,
		8898,
		2518
	],
	"./identity-verification/Status": [
		12281,
		7,
		7407,
		8898,
		2281
	],
	"./identity-verification/Status.tsx": [
		12281,
		7,
		7407,
		8898,
		2281
	],
	"./top-redirect/Index": [
		78051,
		9,
		8051
	],
	"./top-redirect/Index.tsx": [
		78051,
		9,
		8051
	],
	"./transfer/Pending": [
		27820,
		7,
		7407,
		8898,
		7820
	],
	"./transfer/Pending.tsx": [
		27820,
		7,
		7407,
		8898,
		7820
	],
	"./widget/Withdrawability": [
		96388,
		7,
		7407,
		8898,
		6388
	],
	"./widget/Withdrawability.tsx": [
		96388,
		7,
		7407,
		8898,
		6388
	],
	"./widget/declaration/DepositDetails": [
		76102,
		7,
		7407,
		8898,
		6102
	],
	"./widget/declaration/DepositDetails.tsx": [
		76102,
		7,
		7407,
		8898,
		6102
	],
	"./widget/declaration/PopUpload": [
		81419,
		7,
		7407,
		8898,
		1419
	],
	"./widget/declaration/PopUpload.tsx": [
		81419,
		7,
		7407,
		8898,
		1419
	],
	"./withdraw/Authorisation": [
		95772,
		7,
		7407,
		8898,
		5772
	],
	"./withdraw/Authorisation.tsx": [
		95772,
		7,
		7407,
		8898,
		5772
	],
	"./withdraw/Cancelled": [
		69105,
		7,
		7407,
		8898,
		9105
	],
	"./withdraw/Cancelled.tsx": [
		69105,
		7,
		7407,
		8898,
		9105
	],
	"./withdraw/Content": [
		43077,
		7,
		8898,
		3077
	],
	"./withdraw/Content.tsx": [
		43077,
		7,
		8898,
		3077
	],
	"./withdraw/Expired": [
		47118,
		7,
		7407,
		8898,
		7118
	],
	"./withdraw/Expired.tsx": [
		47118,
		7,
		7407,
		8898,
		7118
	],
	"./withdraw/Failed": [
		11889,
		7,
		7407,
		8898,
		1889
	],
	"./withdraw/Failed.tsx": [
		11889,
		7,
		7407,
		8898,
		1889
	],
	"./withdraw/Index": [
		57731,
		7,
		7407,
		8898,
		7731
	],
	"./withdraw/Index.tsx": [
		57731,
		7,
		7407,
		8898,
		7731
	],
	"./withdraw/Initiated": [
		32058,
		7,
		7407,
		8898,
		2058
	],
	"./withdraw/Initiated.tsx": [
		32058,
		7,
		7407,
		8898,
		2058
	],
	"./withdraw/Interrupted": [
		20177,
		7,
		7407,
		8898,
		177
	],
	"./withdraw/Interrupted.tsx": [
		20177,
		7,
		7407,
		8898,
		177
	],
	"./withdraw/LegacyConfirmRedirect": [
		80856,
		7,
		8898,
		856
	],
	"./withdraw/LegacyConfirmRedirect.tsx": [
		80856,
		7,
		8898,
		856
	],
	"./withdraw/ModalClosed": [
		98596,
		7,
		7407,
		8898,
		8596
	],
	"./withdraw/ModalClosed.tsx": [
		98596,
		7,
		7407,
		8898,
		8596
	],
	"./withdraw/NoApplicablePsp": [
		45037,
		7,
		7407,
		8898,
		5037
	],
	"./withdraw/NoApplicablePsp.tsx": [
		45037,
		7,
		7407,
		8898,
		5037
	],
	"./withdraw/Pending": [
		28662,
		7,
		7407,
		8898,
		8662
	],
	"./withdraw/Pending.tsx": [
		28662,
		7,
		7407,
		8898,
		8662
	],
	"./withdraw/PendingSuspicious": [
		51549,
		7,
		7407,
		8898,
		1549
	],
	"./withdraw/PendingSuspicious.tsx": [
		51549,
		7,
		7407,
		8898,
		1549
	],
	"./withdraw/Requested": [
		52336,
		7,
		2336
	],
	"./withdraw/Requested.tsx": [
		52336,
		7,
		2336
	],
	"./withdraw/Success": [
		49241,
		7,
		7407,
		8898,
		9241
	],
	"./withdraw/Success.tsx": [
		49241,
		7,
		7407,
		8898,
		9241
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 74985;
module.exports = webpackAsyncContext;